module.exports = __webpack_public_path__ + "img/IMG_1039_L_Wood.f919209c.jpg";